import { WhatsappIcon,WhatsappShareButton} from 'react-share'

const StatusBar = ({name, room,users, setShowModal }) => {
  return (<div className=" cursor-pointer fixed top-0 left-0 w-full z-20">
  <div className="flex items-center justify-between bg-blue-500 text-white p-4 text-xl">
    
      <div onClick={()=>setShowModal(true)} className="flex-1 flex-col items-center justify-between">
        
        <div>{room}</div>
        
        <div className="text-sm font-semibold">
        {users?.length} Online
        </div> 
      </div>

      <div>
          <WhatsappShareButton className="focus:outline-none hover:scale-x-150 transition duration-150 " title={`You have been invited by *${name}* to room *${room}* , Join Chat Room by entering your name and room-name as *${room}* at `} url={`https://tman-chat-app.netlify.app/`}>
            <WhatsappIcon className="rounded-full" size="28"/>  
          </WhatsappShareButton> 
      </div>

      </div>
    
     </div>
     );
  
};

export default StatusBar;
